//resultUtils.js
import { Sentence } from './models/Sentence';
export const qualtiyColorScheme = (quality) => {
    let retColor = 'white';
    if (quality > 90) retColor = 'lightgreen';
    else if (quality > 50) retColor = 'greenyellow';
    else if (quality > 20) retColor = 'yellow';
    else retColor = 'tomato';
    return retColor;
  }

// Accept a Sentence instance; use its underlying phraseObj for scoring.
export const getBackgroundColor = (sentence) => {
  const defaultColor = '#f5f5f5';
  if (!sentence) return defaultColor;
  const phraseObj = sentence.phraseObj ?? null;
  const hMean = Sentence.avScore(phraseObj);
  if (hMean) {
    return qualtiyColorScheme(hMean * 100);
  }
  return defaultColor;
};
